<web-settings-body>
    <!--
        The breadcrumbs are the only root of their block on purpose: a control-flow
        block with more than one root node projects all of it into the default slot
        (NG8011), and `web-settings-body` renders its breadcrumbs slot separately.
    -->
    @switch (screen()) {
        @case (screenEnum.Main) {
            <web-settings-breadcrumbs>
                <div class="breadcrumb-icon">
                    <a [tooltip]="'site_styles' | translate" placement="bottom" (click)="setSelectedTheme()">
                        <img
                            src="./assets/img/websites/lpc-theme-settings-icon.svg"
                            class="first-breadcrumb-icon"
                            alt="lpc-theme-settings-icon"
                        />
                    </a>
                    <img
                        src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                        class="breadcrumb-arrow-icon"
                        alt="lpc-breadcrumb-arrow-icon"
                    />
                </div>
                <div class="breadcrumb-icon">
                    <img
                        src="./assets/img/websites/lpc-icon-header.svg"
                        class="first-breadcrumb-icon"
                        alt="lpc-block-icon"
                    />
                </div>
                <div class="breadcrumb-text">
                    {{ "header" | translate }}
                </div>
            </web-settings-breadcrumbs>
        }
        @case (screenEnum.Mobile) {
            <web-settings-breadcrumbs>
                <div class="breadcrumb-icon">
                    <a (click)="showScreen(screenEnum.Main)">
                        <img
                            src="./assets/img/websites/lpc-back-icon.svg"
                            class="first-breadcrumb-icon"
                            alt="lpc-back-icon"
                        />
                    </a>
                </div>
                <div class="breadcrumb-text">
                    <span>{{ "control_mobile_view" | translate }}</span>
                </div>
            </web-settings-breadcrumbs>
        }
        @case (screenEnum.CartIcon) {
            <web-settings-breadcrumbs>
                <div class="breadcrumb-icon">
                    <a (click)="showScreen(screenEnum.Main)">
                        <img
                            src="./assets/img/websites/lpc-back-icon.svg"
                            class="first-breadcrumb-icon"
                            alt="lpc-back-icon"
                        />
                    </a>
                </div>
                <div class="breadcrumb-text">
                    <span>{{ "shop_cart_icon_style" | translate }}</span>
                </div>
            </web-settings-breadcrumbs>
        }
    }

    @switch (screen()) {
        @case (screenEnum.Main) {
            <a [href]="'knowledge_base_header_link' | translate" class="kb-link" target="_blank">
                <span class="small sp-icon icon-info"> </span> {{ "knowledge_base_header_tooltip" | translate }}
                <span class="color-light small sp-icon icon-outgoing"> </span>
            </a>

            <div class="panel-options-body overflow-wrapper">
                <div class="form form-horizontal">
                    <div class="form-row">
                        <div class="form-group">
                            <label class="col-xs-9 control-label">
                                {{ "control_background_color" | translate }}
                            </label>
                            <div class="col-xs-3">
                                <web-color-picker
                                    [color]="backgroundColor()"
                                    (colorChangeEvent)="setBackgroundColor($event)"
                                />
                            </div>
                        </div>

                        <div class="mb-20">
                            <web-background-image-settings
                                [allowImageEffects]="false"
                                [background]="background()"
                                (backgroundChange)="setBackground($event)"
                                (showEditImageModalEvent)="showEditImageModal()"
                            />
                        </div>

                        <div class="form-group mb-20">
                            <label class="col-xs-9 control-label">
                                {{ "control_full_width" | translate }}
                            </label>
                            <div class="col-xs-3 text-right">
                                <sp-switch [active]="isFullWidth()" (toggleActiveEvent)="setIsFullWidth($event)" />
                            </div>
                        </div>

                        @if (canHaveSeparator()) {
                            <div class="form-group mb-20">
                                <label class="col-xs-9 control-label">
                                    {{ "control_add_separator" | translate }}
                                </label>
                                <div class="col-xs-3 text-right">
                                    <sp-switch
                                        [active]="hasSeparator()"
                                        (toggleActiveEvent)="setHasSeparator($event)"
                                    />
                                </div>
                            </div>
                        }

                        @if (canPinToTop()) {
                            <div class="form-group mb-20">
                                <label class="col-xs-9 control-label">
                                    {{ "control_top_fixed_block" | translate }}
                                </label>
                                <div class="col-xs-3 text-right">
                                    <sp-switch [active]="pinOnTheTop()" (toggleActiveEvent)="setPinOnTheTop($event)" />
                                </div>
                            </div>
                        }

                        @if (canPinToBottom()) {
                            <div class="form-group mb-20">
                                <label class="col-xs-9 control-label">
                                    {{ "control_bottom_fixed_block" | translate }}
                                </label>
                                <div class="col-xs-3 text-right">
                                    <sp-switch
                                        [active]="pinOnTheBottom()"
                                        (toggleActiveEvent)="setPinOnTheBottom($event)"
                                    />
                                </div>
                            </div>
                        }

                        <div class="form-group mb-20">
                            <div class="col-xs-12">
                                <a class="dotted" (click)="showScreen(screenEnum.Mobile)">
                                    {{ "control_mobile_view" | translate }}
                                </a>
                            </div>
                        </div>

                        @if (isCartEnabled()) {
                            <div class="form-group mb-20">
                                <div class="col-xs-12">
                                    <a class="dotted" (click)="showScreen(screenEnum.CartIcon)">
                                        {{ "shop_cart_icon_style" | translate }}
                                    </a>
                                </div>
                            </div>
                        }

                        @if (isAdmin()) {
                            <hr class="panel-options-divider" />
                            <web-block-library-addon [blockId]="entity().id" />
                        }
                    </div>
                </div>

                <hr class="panel-options-divider" />

                <div class="mt-20">
                    <web-custom-id [displayId]="displayId()" (valueChangeEvent)="setDisplayId($event)" />
                </div>
            </div>
        }
        @case (screenEnum.Mobile) {
            <web-specific-block-mobile-settings
                [entity]="entity()"
                [form]="form"
                (cancelEvent)="showScreen(screenEnum.Main)"
            />
        }
        @case (screenEnum.CartIcon) {
            <sp-shop-cart-icon-settings [isMobile]="isDeviceMobile()" />
        }
    }
</web-settings-body>
